<div class="container-fluid section-header">
<!--  <img *ngIf="data?.background?.url" [src]="data.background.url">-->
  <div class="header-background-image" [style.backgroundImage]="'url(' + data.background.url + ')'"></div>
  <div class="header-background-image-overlay"></div>

  <div class="header-section-container">
    <h1 [innerHTML]="data.title | marked" class="d-block"></h1>
    <p class="d-block">{{data.subtitle}}</p>
    <div class="d-block">
      <a routerLink="test" class="d-block">{{ "Take a test" | trans: 'main.header_cta' }}</a>
    </div>
  </div>
</div>


